// src/utils/common.ts
// FIREBASE REMOVED - PostgreSQL kullanıyoruz artık

/**
 * @deprecated Firebase kaldırıldı - Backend API kullanın
 * Ortak Firestore sorgu fonksiyonları - Artık kullanılmıyor
 */
export const firestoreUtils = {
    /**
     * @deprecated Firebase kaldırıldı - Backend API kullanın
     */
    async getAllDocs(_path: string): Promise<Array<{ id: string; [key: string]: any }>> {
        return [];
    },

    /**
     * @deprecated Firebase kaldırıldı - Backend API kullanın
     */
    async getFilteredDocs(_path: string, _field: string, _operator: any, _value: any): Promise<Array<{ id: string; [key: string]: any }>> {
        return [];
    },

    /**
     * @deprecated Firebase kaldırıldı - Backend API kullanın
     */
    async getOrderedDocs(_path: string, _orderField: string, _orderDirection: 'asc' | 'desc' = 'desc', _limitCount: number | null = null): Promise<Array<{ id: string; [key: string]: any }>> {
        return [];
    }
};

/**
 * Ortak format fonksiyonları
 */
export const formatUtils = {
    /**
     * Para birimi formatı
     * @param amount - Miktar
     * @param currency - Para birimi
     * @returns Formatlanmış para
     */
    currency(amount: number, currency: string = 'TRY'): string {
        return new Intl.NumberFormat('tr-TR', {
            style: 'currency',
            currency: currency
        }).format(amount);
    },

    /**
     * Sayı formatı
     * @param number - Sayı
     * @returns Formatlanmış sayı
     */
    number(number: number): string {
        return new Intl.NumberFormat('tr-TR').format(number);
    },

    /**
     * Tarih formatı
     * @param date - Tarih
     * @param format - Format türü ('date', 'datetime', 'time')
     * @returns Formatlanmış tarih
     */
    date(date: Date | null | undefined, format: 'date' | 'datetime' | 'time' = 'date'): string {
        if (!date) return '-';
        
        let dateObj: Date;
        if (date instanceof Date) {
            dateObj = date;
        } else {
            return '-';
        }

        const options: Intl.DateTimeFormatOptions = {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        };

        if (format === 'datetime') {
            options.hour = '2-digit';
            options.minute = '2-digit';
        } else if (format === 'time') {
            return new Intl.DateTimeFormat('tr-TR', {
                hour: '2-digit',
                minute: '2-digit'
            }).format(dateObj);
        }

        return new Intl.DateTimeFormat('tr-TR', options).format(dateObj);
    }
};

/**
 * Hata yönetimi yardımcı fonksiyonları
 */
export const errorUtils = {
    /**
     * Hata mesajını formatlar
     * @param error - Hata objesi veya string
     * @returns Formatlanmış hata mesajı
     */
    formatError(error: unknown): string {
        if (error instanceof Error) {
            return error.message;
        }
        if (typeof error === 'string') {
            return error;
        }
        return 'Bilinmeyen bir hata oluştu';
    },

    /**
     * Hata loglar
     * @param error - Hata objesi
     * @param context - Hata bağlamı
     */
    logError(_error: unknown, _context?: string): void {
    }
};

